<div class="flex items-center gap-2 mb-3 text-sm font-bold uppercase tracking-wider text-gray-600">
  <i nz-icon nzType="shopping-cart" nzTheme="outline"></i>
  <span>{{'calendar.form.products' | translate}}</span>
  <span class="flex-1 h-px bg-gray-200"></span>
  <button [disabled]="!serviceId || viewOnly || bookingStatus == 2" nz-button nzSize="small" (click)="addEditProduct()">
    <i nz-icon nzType="plus"></i>
  </button>
</div>
<div nz-row [nzGutter]="[8, 8]" class="overflow-row">
  @for (item of serviceProducts; track item; let i = $index) {
    <div nz-col [nzSpan]="12">
      <nz-card
        >
        {{ item?.product?.name || item?.productName }}
        <div nz-row nzJustify="space-between">
          <div nz-col>
            <nz-space [nzSize]="8">
              <div *nzSpaceItem>
                @if (item.quantitySum) {
                  <span>{{ item.quantitySum }} ცალი</span>
                }
                @if (item.grSum) {
                  <span>{{ item.grSum }} {{'calendar.form.gram' | translate }}</span>
                }
              </div>
              <span *nzSpaceItem>{{ item.price }} {{'calendar.form.gel' | translate }}</span>
            </nz-space>
          </div>
          <div nz-col>
            <nz-space [nzSize]="8">
              @if (!viewOnly && bookingStatus != 2) {
                <i
                  *nzSpaceItem
                  nz-icon
                  nzType="edit"
                  nzTheme="outline"
                  style="cursor: pointer"
                  (click)="addEditProduct(item)"
                ></i>
              }
              @if (!viewOnly && bookingStatus != 2) {
                <i *nzSpaceItem
                  nz-popconfirm
                  nzPopconfirmTitle="{{'buttons.deletePop' | translate}}"
                  nzPopconfirmPlacement="bottom"
                  (nzOnConfirm)="delete(i)"
                  nz-icon
                  nzType="delete"
                  nzTheme="outline"
                  style="cursor: pointer"
                ></i>
              }
            </nz-space>
          </div>
        </div>
      </nz-card>
    </div>
  }
</div>
